import { State } from "country-state-city";

// export const server = "http://localhost:5000/api/v1";
export const server = "https://server.testsetu.in/api/v1";
export const tinyMceKey = "u2j0p691ks3c6dphfk92onc7d3w2jzios9fswzwkak2vsysf";
export const STATES_LIST = State.getStatesOfCountry("IN");

export const defaultUserImage = "";
